module.exports = "/assets/_next/static/images/avatar-watermark-large-04abb1b9ebce5942a063db6ed4caf568.png";